import type { FullAddress } from '../../types';

export const getCompleteAddress = (fullAddress: FullAddress) => {
  const {
    street,
    municipality,
    region,
    postalCode,
    addressNumber: aNumber,
  } = fullAddress;

  const addressNumber = aNumber || '';

  return `${addressNumber} ${street}, ${municipality}, ${region}, ${postalCode}`;
};
